export default {
	dependencies: {
		title: "Abhängigkeiten",
		hint: "Typen, Datenobjekte und Aktivitäten eines anderen Projekts, auf eine Version festgelegt. Seine Entitäten werden Teil des Vokabulars dieses Projekts — schreibgeschützt, da sie im anderen Projekt liegen.",
		add: "Abhängigkeit hinzufügen",
		sync: "Neu auflösen",
		synced: "Abhängigkeiten neu aufgelöst.",
		syncedWithImpact: "Neu aufgelöst. Einige Entitäten existieren nicht mehr: {aliases}.",
		empty: "Noch keine Abhängigkeiten.",
		sourceProject: "Quellprojekt",
		version: "Version",
		nothingBuilt:
			"Das gewählte Projekt hat noch keine gebauten Versionen. Bauen oder veröffentlichen Sie es zuerst.",
		alias: "Alias",
		aliasHelp:
			"Der lokale Name dieser Abhängigkeit. Kleinbuchstaben, Ziffern, Bindestriche und Unterstriche.",
		aliasInvalid:
			"Nur Kleinbuchstaben, Ziffern, Bindestriche und Unterstriche verwenden, höchstens 64 Zeichen.",
		aliasTaken: "Dieser Alias wird bereits verwendet.",
		added: "Abhängigkeit „{alias}“ hinzugefügt.",
		updated: "Abhängigkeit „{alias}“ aktualisiert.",
		removed: "Abhängigkeit „{alias}“ entfernt.",
		remove: "Entfernen",
		definedIn: "definiert in {alias}",
		predefined: "von Notitia vordefiniert",
		predefinedReadOnly: "Von Notitia vordefiniert und hier deshalb schreibgeschützt.",
		readOnly:
			"Definiert in {alias} und hier deshalb schreibgeschützt. Ändern lässt es sich nur im Quellprojekt.",
		changeVersion: "Auf {version} wechseln",
		wipOption: "wip (nicht reproduzierbar)",
		wipWarning:
			"Ein wip-Pin folgt dem aktuellen Stand des Quellprojekts. Zwei Builds zu verschiedenen Zeitpunkten können unterschiedliche Inhalte verwenden — wenn es auf Reproduzierbarkeit ankommt, veröffentlichen Sie eine Version.",
		stale: "Die Quelle von „{alias}“ hat sich seit dem Auflösen geändert. Nichts, was dieses Projekt verwendet, ist betroffen — die neue Version ist bereits im Einsatz. Neu auflösen, um sie festzuhalten.",
		sourceNotReadable:
			"Für eine Abhängigkeit von diesem Projekt benötigen Sie die Berechtigung, seine Builds zu lesen.",
		pending: {
			title: "Änderungen an „{alias}“ warten auf Ihre Prüfung",
			body: "Die Quelle von „{alias}“ hat sich geändert. Eine Übernahme würde {count} Verweis in diesem Projekt ungültig machen. Änderungen, die Code neu erzeugen, sind gesperrt, bis Sie neu auflösen. | Die Quelle von „{alias}“ hat sich geändert. Eine Übernahme würde {count} Verweise in diesem Projekt ungültig machen. Änderungen, die Code neu erzeugen, sind gesperrt, bis Sie neu auflösen.",
			adopt: "Übernehmen und neu auflösen",
			collisions: "Namenskollisionen",
			collisionsHeld:
				"Neu auflösen ist erst möglich, wenn ein Quellprojekt einen der beiden Namen ändert.",
		},
		surfaceUnavailable:
			"Dieses Paket konnte nicht gelesen werden, die Abhängigkeit steuert daher nichts bei. Der Pin bleibt erhalten.",
		collision:
			"Ein Name aus dieser Abhängigkeit kollidiert mit einem bereits vorhandenen. Das lässt sich hier nicht beheben: Der Klassenname ist die Identität zur Laufzeit, und ein Umbenennen beim Bauen würde dazu führen, dass sich keine Beziehungen mehr anlegen lassen. In einem der beiden Quellprojekte umbenennen und veröffentlichen.",
		diagnostics: {
			wipMoved:
				"Eine Abhängigkeit hat sich seit dem letzten Auflösen geändert. Nichts, was dieses Projekt verwendet, ist betroffen — die neue Version ist im Einsatz.",
			wipBlocked:
				"Eine Abhängigkeit hat sich auf eine Weise geändert, die dieses Projekt betrifft. Auswirkungen in den Abhängigkeits-Einstellungen prüfen und neu auflösen, um fortzufahren.",
			selectPresentationPruned:
				"Ein Typ einer Abhängigkeit hat einige Werte nicht mehr, die Fragen hier sortiert oder mit eigener Farbe oder eigenem Bild versehen hatten. Diese Einstellungen wurden entfernt. Alles andere ist unverändert.",
		},
		notice: {
			blocked: "Abhängigkeit prüfen",
			blockedTooltip:
				"„{aliases}“ hat sich auf eine Weise geändert, die dieses Projekt betrifft. Auswirkungen prüfen und neu auflösen, um fortzufahren — Änderungen, die Code neu erzeugen, sind bis dahin gesperrt.",
			moved: "Abhängigkeit geändert",
			movedTooltip:
				"„{aliases}“ hat sich geändert. Nichts, was dieses Projekt verwendet, ist betroffen — die neue Version ist bereits im Einsatz. Neu auflösen, um sie festzuhalten.",
		},
		impact: {
			title: "Was sich für „{alias}“ ändert",
			none: "Nichts in diesem Projekt verweist auf Entitäten, die diese Änderung entfernt.",
			warning:
				"Nach dieser Änderung würden die folgenden Verweise auf nicht mehr existierende Entitäten zeigen.",
			bestEffort:
				"Per Textsuche im Code gefunden — diese Liste ist ein Hinweis, keine vollständige Aufzählung.",
			refused:
				"Die Änderung wurde abgelehnt, weil sie die folgenden Verweise ungültig machen würde. Prüfen Sie diese, und wenden Sie die Änderung dann trotzdem an oder brechen Sie ab.",
			groups: {
				attributes: "Attribute",
				relations: "Beziehungen",
				process_entries: "Prozesseinträge",
				activity_bindings: "Aktivitätsbindungen",
				axioms: "Axiome",
				custom_action_bodies: "Code in Eigenen Aktionen",
				activities: "Aktivitäten",
				action_types: "Aktionstypen",
				union_members: "Union-Typen",
				views: "Ansichten",
				attribute_paths: "Attributpfade",
				type_values: "Typwerte",
				terminology_overrides: "Von Ihnen umbenannte Begriffe",
			},
			notes: {
				views: "Die Änderung entfernt diese aus den Ansichten, die sie auflisten.",
				terminology_overrides:
					"Die Änderung verwirft diese Umbenennungen: Keine verbleibende Entität verwendet den Begriff.",
			},
		},
		npm: {
			title: "npm-Pakete",
			hint: "Gewöhnliche npm-Pakete für den Code in Eigenen Aktionen. Geprüft wird nur die Syntax von Name und Versionsbereich — ein Paket, das es nicht gibt, fällt erst beim Bauen auf.",
			add: "Paket hinzufügen",
			added: "Paket hinzugefügt.",
			removed: "„{name}“ entfernt.",
			empty: "Keine npm-Pakete.",
			name: "Paketname",
			range: "Versionsbereich",
			rangeHelp: "Ein Semver-Bereich, zum Beispiel ^4.1.0.",
			dev: "Dev-Abhängigkeit",
		},
	},
};
